import { isArray, isEmpty, isFunction, isObject } from "lodash-es";
import React from "react";
import { CardTitle } from "reactstrap";
import { getAddSizeUnit } from "../../utils/size";
import { classnames } from "../../utils/text";
import Button from "../Button";
import Line from "../Line";
import FormItem from "./FormItem";

const Form = ({
  fields,
  mode = "create", //  detail, create, modify, view  쓰기 혹은 보기 전체로 바꾸기 위함
  buttons = [],
  cancel,
  cancelText = "취소",
  submit,
  submitText = "작성완료",
  onChange,
  form,
  setForm,
  errors,
  className,
  children,
  isRequiredShow, // required 표기 옵션
  isDisabledSubmit, // 작성버튼 disabled
}) => {
  const transObjectForm = (_fields, index) => {
    let objForm;

    switch (_fields.type) {
      case "hide":
        objForm = <></>
        break;
      case "line":
        objForm = !(
          (isFunction(_fields.isHide) && _fields.isHide({ form })) ||
          (!isFunction(_fields.isHide) && _fields.isHide)
        ) && <Line key={`line-${index}`} className="form-line" />;
        break;
      case "dashed":
        objForm = !(
          (isFunction(_fields.isHide) && _fields.isHide({ form })) ||
          (!isFunction(_fields.isHide) && _fields.isHide)
        ) && <Line key={`line-${index}`} className="form-line" />;
        break;
      case "title":
        objForm = (
          <div
            key={`section-title-${index}`}
            className={`section-title-wrap section-title-${index}`}
          >
            <CardTitle className="color-gray-7">{_fields.title}</CardTitle>
          </div>
        );
        break;
      case "sub-title":
      case "section-title":
        objForm = (
          <div key={`section-title-${index}`} className="section-title-wrap">
            <p className={`form-section-title ${_fields.className}`}>
              {_fields.title}
            </p>
          </div>
        );
        break;
      case "badge-section-title":
        objForm = (
          <div
            key={`section-badge-title-${index}`}
            className="section-title-wrap"
          >
            <p className={`form-section-title badge ${_fields.className}`}>
              {_fields.title}
            </p>
          </div>
        );
        break;
      default:
        objForm = (
          <FormItem
            setForm={setForm}
            key={`obj-form-${index}`}
            field={_fields}
            mode={mode}
            style={{
              width: _fields.width
                ? getAddSizeUnit(_fields.width)
                : `calc(100%)`,
            }}
            isRequiredShow={isRequiredShow}
            form={form}
            onChange={_fields.onChange || onChange}
            errors={errors}
            {..._fields}
          />
        );
        break;
    }

    return objForm;
  };

  return (
    <div
      className={classnames("data-form clear", `data-form-${mode}`, className)}
    >
      {fields &&
        fields.map((_fields, index) => (
          <div className="clear" key={index}>
            {isArray(_fields) ? (
              _fields.map(({ key, ...field }, idx) => (
                <FormItem
                  setForm={setForm}
                  mode={mode}
                  field={{ key, ...field }}
                  key={`${index}-${idx}`}
                  isRequiredShow={isRequiredShow}
                  style={{
                    width: field.width
                      ? getAddSizeUnit(field.width)
                      : `calc(100% / ${_fields.length})`,
                  }}
                  form={form}
                  onChange={onChange}
                  errors={errors}
                  className={classnames(
                    `items-multi items-total-${_fields.length}`,
                    { first: idx === 0, last: _fields.length === idx + 1 }
                  )}
                  {...field}
                />
              ))
            ) : // _fields 가 Object인 경우
              isObject(_fields) && !isFunction(_fields) ? (
                (isFunction(_fields.isHide) && _fields.isHide({ form })) ||
                  (!isFunction(_fields.isHide) && _fields.isHide) ? (
                  <React.Fragment key={index}></React.Fragment>
                ) : (
                  transObjectForm(_fields, index)
                )
              ) : (
                // _fields 가 Array, Object 가 아닌 경우 그대로 return
                <React.Fragment key={index}>
                  {isFunction(_fields)
                    ? _fields({
                      fields,
                      mode,
                      cancel,
                      submit,
                      onChange,
                      form,
                      errors,
                      className,
                      isRequiredShow,
                    })
                    : _fields}
                </React.Fragment>
              )}
          </div>
        ))}
      {children && (
        <div className="data-form-item form-children-wrap">{children}</div>
      )}
      {buttons && !isEmpty(buttons) && (
        <div className="form-button-wrap print-out">
          {buttons.map((button, idx) => {
            return (
              <React.Fragment key={idx}>
                {!button.isHide && <Button {...button} />}
              </React.Fragment>
            );
          })}
        </div>
      )}
      {(cancel || submit) && (
        <div className="form-button-wrap print-out">
          {cancel && (
            <Button color={"text"} onClick={cancel}>
              {cancelText}
            </Button>
          )}
          {submit && !(mode === "detail" || mode === "view") && (
            <Button onClick={submit} disabled={isDisabledSubmit}>
              {submitText}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default Form;
